module.exports = __webpack_public_path__ + "static/media/Tosee_Saderat.7256a55c.svg";